// Kept in this browser only on purpose, so the choice does not follow the user across devices.
export const getStoredFlag = (key: string): boolean => {
  try {
    return localStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
};

export const storeFlag = (key: string, enabled: boolean): void => {
  try {
    localStorage.setItem(key, String(enabled));
  } catch {
    // Ignore write failures (storage disabled or over quota) — the choice still applies for this session.
  }
};
